import Pagination from "@material-ui/lab/Pagination";

import { TableLoadSpinner } from "../../common/LoadSpinner/LoadSpinner";
import check from "../../../images/check.svg";
import x from "../../../images/x.svg";
import { ActionButton } from "../../common/Buttons/Buttons";
import "../../common/Tables/Tables.scss";

export const RideryCodesTable = ({
    header,
    dataTable,
    handlePageChange,
    handleAction,
    isLoading = false,
    changeStatusCode
  }) => {

  return (
    <>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
              </th>
            ))}
          </tr>
          </thead>

          <tbody>
            {dataTable?.data.length > 0 &&
            !isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td>{d?.code}</td>
                <td>
                  {d?.status === "Activo" && <img src={check} alt="check" />}
                  {d?.status === "Bloqueado" && <img src={x} alt="x" />}
                  {d?.status === "Enviado" && ""}
                  {" "}
                  {d?.status}
                </td>
                <td className="table-buttons-style-conatiner">
                  {
                    d?.status !== "Enviado" && (
                        <ActionButton
                            style={{ backgroundColor: "#f27730", color: "white" }}
                            action={() =>
                            changeStatusCode({
                                isOpen: true,
                                data: {
                                    name: d?.firstName + " " + d?.lastName,
                                    id: d?._id,
                                    status: d?.status,
                                },
                                
                            })
                            }
                            label={d?.status === "Activo" ? "Bloquear" : "Activar"}
                        />
                    )
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {isLoading && <TableLoadSpinner show={isLoading} />}
      {dataTable?.data.length <= 0 && !isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};